export default class sogetiSettingsEditor {
    constructor() {
        return {
            restrict: 'E',
            template: require('../../../../views/event/directives/sogeti-settings-editor.html'),
            controller: SogetiSettingsCtrl,
            controllerAs: 'sogeti'
        }
    }
};

class SogetiSettingsCtrl {
    constructor($scope, Sogeti) {
        this._scope = $scope;
        
        this.sogetiService = Sogeti;
        
        this.locationSettings = false;

        this._scope.$on('event:settings:setupLocationSettings', (event, data) => {
            this.event = data.event;
            this.setup();
        });
    }
    
    setup() {
        this.countries = this.sogetiService.getCountries();
        this.offices = this.sogetiService.getOffices(this.event.account_id);
        this.divisions = this.sogetiService.getDivisions();
        let settings = this.sogetiService.getLocationSettings(this.event.account_id);

        if (! this.event.metadata.data || ! this.event.metadata.data.country) {
            this.event.metadata.data.country = settings.country;
        }

        if (! this.event.metadata.data || ! this.event.metadata.data.division) {
            this.event.metadata.data.division = settings.division;
        }

        if (! this.event.metadata.data || ! this.event.metadata.data.office) {
            this.event.metadata.data.office = settings.office;
        }
    }

    toggleLocationSettings() {
        this.locationSettings = ! this.locationSettings;
        this._scope.$emit('event:locationSettings', this.locationSettings);
    };
}
